import React from 'react';
// Constants
import { CompanyName, CONTACT_PAGE_URL } from '../../utils/Constants';

function GeneralHeader({ topLine, title, subHeader, lineText, linkRequired }) {
  return (
    <header className='grid w-full '>
      <div className='grid gap-4 lg:gap-6 py-10'>
        {/* Main Header */}
        <section className='grid justify-center text-center leading-4'>
          <article className='grid h-fit'>
            <div className='flex items-center justify-center'>
              <p className='text-colour4 dark:text-colour4 font-kugile text-xl lg:text-3xl font-semibold'>
                {topLine}
              </p>
            </div>
            <div className='grid h-fit'>
              <h1 className='text-colour1 overflow-hidden dark:text-colour1 font-hello-paris-medium text-6xl sm:text-7xl md:text-8xl lg:text-9xl'>
                {title}
              </h1>
              <h2 className='text-3xl md:text-3xl lg:text-4xl font-kugile'>
                {subHeader}
              </h2>
            </div>
          </article>
        </section>
      </div>
    </header>
  );
}

export default GeneralHeader;
